"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPressableButton = void 0;
const retrommo_types_1 = require("retrommo-types");
const pixel_pigeon_1 = require("pixel-pigeon");
const createPressableButton = ({ condition, height, imagePath, onClick, text, width, x, y, }) => {
    const buttonIDs = [];
    const labelIDs = [];
    const spriteIDs = [];
    const pressableButtonState = new pixel_pigeon_1.State({
        isPressed: false,
    });
    spriteIDs.push((0, pixel_pigeon_1.createSprite)({
        animationID: () => {
            if (pressableButtonState.values.isPressed) {
                return "pressed";
            }
            return "default";
        },
        animations: [
            {
                frames: [
                    {
                        height,
                        sourceHeight: 8,
                        sourceWidth: 8,
                        sourceX: 0,
                        sourceY: 0,
                        width,
                    },
                ],
                id: "default",
            },
            {
                frames: [
                    {
                        height,
                        sourceHeight: 8,
                        sourceWidth: 8,
                        sourceX: 8,
                        sourceY: 0,
                        width,
                    },
                ],
                id: "pressed",
            },
        ],
        coordinates: {
            condition,
            x,
            y,
        },
        imagePath,
    }));
    labelIDs.push((0, pixel_pigeon_1.createLabel)({
        color: retrommo_types_1.Color.White,
        coordinates: {
            condition,
            x: (typeof x === "function" ? x() : x) + width / 2,
            y: () => {
                if (pressableButtonState.values.isPressed) {
                    return y + 3;
                }
                return y + 1;
            },
        },
        horizontalAlignment: "center",
        text,
    }));
    buttonIDs.push((0, pixel_pigeon_1.createButton)({
        coordinates: {
            condition,
            x,
            y,
        },
        height,
        onClick,
        onMouseDown: () => {
            pressableButtonState.setValues({ isPressed: true });
        },
        onRelease: () => {
            pressableButtonState.setValues({ isPressed: false });
        },
        width,
    }));
    return {
        buttonIDs,
        labelIDs,
        spriteIDs,
    };
};
exports.createPressableButton = createPressableButton;
